import React from 'react'
import { graphql, useStaticQuery, Link } from 'gatsby'
import { HeaderProvider } from './HeaderContext'
import UtilityNav from './UtilityNav'
import PrimaryNav from './PrimaryNav'
import Toggle from './Toggle'
import logo from '@/images/stepup-logo-white.svg'
import * as css from './Header.module.css'

const App = () => {
	const { header } = useStaticQuery(query)

	return (
		<header className="sticky top-0 z-20 bg-white">
			<UtilityNav nav={header.utilityNav} />

			<div className="bg-orange text-white">
				<div className={css.primary}>
					<div className="grid justify-start [grid-area:logo]">
						<Link className="inline-block p-4" to="/">
							<img className="max-h-[40px] <md:max-h-[30px]" src={logo} alt="Step Up" />
						</Link>
					</div>

					<Toggle />

					<PrimaryNav nav={header.primaryNav} />
				</div>
			</div>
		</header>
	)
}

const Header = () => <HeaderProvider children={<App/>} />

export default Header

export const query = graphql`query Header {
	header: sanityHeader {
		utilityNav {
			...link
		}
		primaryNav {
			...link
			...linkGroup
		}
	}
}`
